/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Drop_TitleInputs */



/**
* | output |
* | --- |
* | "Drop your PowerPoint template here" |
*
* @param {Presentation_Template_Drop_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_drop_title = /** @type {((inputs?: Presentation_Template_Drop_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Drop_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("PowerPoint-Vorlage hier ablegen")
	return /** @type {LocalizedString} */ ("Drop your PowerPoint template here")
});